import { Hosts } from '.';
import productionHosts from './production';

const hosts: Hosts = {
  ...productionHosts,
  CTL_AUTHENTICATOR_SERVER: 'https://auth-ctl.csg-stg.lunit.in',
  CTL_DATA_SERVER: 'https://data-ctl.csg-stg.lunit.in',
  CTL_IMAGE_SERVER: 'https://image-ctl.csg-stg.lunit.in',
};

export default hosts;
